export default __webpack_public_path__ + "static/media/khajuraho-1952716_1280.aecff701.jpg";